import { createContext } from 'react'

const CurrentDocumentContext = createContext<string>('')

export default CurrentDocumentContext
